import { render, staticRenderFns } from "./EmployeeAssignmentsBadge.vue?vue&type=template&id=6cdbb4e5&scoped=true"
import script from "./EmployeeAssignmentsBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeeAssignmentsBadge.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EmployeeAssignmentsBadge.vue?vue&type=style&index=0&id=6cdbb4e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdbb4e5",
  null
  
)

export default component.exports